module.exports = __webpack_public_path__ + "media/images/pic/brodno/teddy-small-2e89404fe6fd60f9a3ed31efe8d00692.webp";